import { graphql } from '@/gql';
import { queryExecute } from '@/Utils/graphqlAPI';
import type { TotalOrderInfo } from '@/models/caller';

export const fetchTotalOrderInfo = async (callerId: string): Promise<TotalOrderInfo | null> => {
  const response = await queryExecute({
    variables: {
      callerId,
    },
    fetchPolicy: 'no-cache',
    query: graphql(`
      query TotalOrderInfo($callerId: String!) {
        totalOrderInfo(callerId: $callerId) {
          totalRides
          totalFreeRides
          partiallyFreeRides
          totalGourmets
          totalGroceries
          totalRideNeedLoves
          totalLostItemNeedLoves
          totalGourmetNeedLoves
          totalGroceryNeedLoves
          totalFreeMonthsPlans
          totalRetentionCredits
        }
      }
    `),
  });

  return response.data.totalOrderInfo ?? null;
};
